import { useEffect, useState } from "react";

import { orientationFromViewport, type ScreenOrientation } from "~/helpers/deviceOrientationPreview";

export interface ViewportMetrics {
	currentOrientation: ScreenOrientation;
	viewportHeight: number;
	viewportWidth: number;
}

const readViewportMetrics = (): ViewportMetrics => ({
	currentOrientation: orientationFromViewport(window.innerWidth, window.innerHeight),
	viewportHeight: window.innerHeight,
	viewportWidth: window.innerWidth
});

const useViewportMetrics = (): ViewportMetrics => {
	const [metrics, setMetrics] = useState(readViewportMetrics);

	useEffect(() => {
		const update = () => setMetrics(readViewportMetrics());
		window.addEventListener("resize", update);
		window.addEventListener("orientationchange", update);
		return () => {
			window.removeEventListener("resize", update);
			window.removeEventListener("orientationchange", update);
		};
	}, []);

	return metrics;
};

export default useViewportMetrics;
